import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import WhatsAppFloat from "./components/layout/WhatsAppFloat";
import Home from "./pages/Home";
import AboutPage from "./pages/AboutPage";
import ProgramsPage from "./pages/ProgramsPage";
import GalleryPage from "./pages/GalleryPage";
import AdmissionPage from "./pages/AdmissionPage";
import ContactPage from "./pages/ContactPage";
import BlogPage from "./pages/BlogPage";
import FranchisePage from "./pages/FranchisePage";
import CareersPage from "./pages/CareersPage";
import EventsPage from "./pages/EventsPage";
import AlbumsPage from "./pages/AlbumsPage";
import VideosPage from "./pages/VideosPage";
import VirtualTourPage from "./pages/VirtualTourPage";
import KnowledgeHousePage from "./pages/KnowledgeHousePage";
import LittleMindCraftWorkPage from "./pages/LittleMindCraftWorkPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/programs" element={<ProgramsPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:id" element={<BlogPage />} />
            <Route path="/franchise" element={<FranchisePage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/albums" element={<AlbumsPage />} />
            <Route path="/albums/:id" element={<AlbumsPage />} />
            <Route path="/videos" element={<VideosPage />} />
            <Route path="/virtual-tour" element={<VirtualTourPage />} />
            <Route path="/knowledge-house" element={<KnowledgeHousePage />} />
            <Route path="/little-mind-craft-work" element={<LittleMindCraftWorkPage />} />
            <Route path="/admission" element={<AdmissionPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFloat />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
